__turbopack_context__.v({
  "root": "FilterWrapper-module-scss-module__tKnaoa__root",
});
